import { gql } from "lib/apolloClient";
import {
  courseOverviewCountFragments,
  plannerElementNodeSetFragments,
} from "./Fragments";
import { pypElementFragment } from "modules/CommonFragments";

export const getCourseOverviewElementSetsNotCoveredCountQuery = gql`
  query getCourseOverviewElementSetsNotCoveredCount(
    $id: ID!
    $filters: InsightCurriculumFilter!
  ) {
    node(id: $id, type: COURSE) {
      id
      ... on Course {
        id
        genericYearlyInsight(filters: $filters) {
          elementSetsNotCovered {
            ...elementSetCoverageCount
          }
          elementSetsCovered {
            ...elementSetCoverageCount
          }
          elementsCovered {
            type
            totalCount
            directlyTaggedUnitPlansCount
            plannerElementNode {
              id
            }
            unitPlans {
              id
            }
            directlyTaggedUnitPlans {
              id
            }
          }
        }
      }
    }
  }
  ${courseOverviewCountFragments.elementSetCoverageCount}
`;
export const getCourseOverviewElementSetsNotCoveredCountInLearningCourseQuery = gql`
  query getCourseOverviewElementSetsNotCoveredCountInLearningCourse(
    $id: ID!
    $filters: InsightCurriculumFilter!
  ) {
    node(id: $id, type: LEARNING_COURSE) {
      ... on LearningCourse {
        id
        learningCourseOverview(filters: $filters) {
          elementSetsNotCovered {
            ...elementSetCoverageCount
          }
          elementSetsCovered {
            ...elementSetCoverageCount
          }
          elementsCovered {
            type
            totalCount
            directlyTaggedUnitPlansCount
            plannerElementNode {
              id
            }
            unitPlans {
              id
            }
            directlyTaggedUnitPlans {
              id
            }
          }
        }
      }
    }
  }
  ${courseOverviewCountFragments.elementSetCoverageCount}
`;

export const getPYPYearlyInsightsQuery = gql`
  query getPYPYearlyInsights(
    $id: ID!
    $filters: PYPCourseYearlyInsightFilters
  ) {
    node(id: $id, type: COURSE) {
      id
      ... on Course {
        id
        pypYearlyInsight(filters: $filters) {
          ... on ATLYearlyInsight {
            type
            elementsNotCovered {
              elements {
                id
                label
                children
                parent
                isLeaf
                atlCategory {
                  id
                }
                subText
                grades {
                  id
                  name
                }
              }
              nodes {
                id
                label
                children
                parent
                isLeaf
                atlCategory {
                  id
                }
                subText
                grades {
                  id
                  name
                }
              }
              leafNodeCount
              nodesCount
            }
            elementsCovered {
              leafNodeCount
              nodesCount
            }
          }
          ... on KeyConceptYearlyInsight {
            type
            elementsNotCovered_: elementsNotCovered {
              elements {
                ...conceptItem
              }
              nodes {
                ...conceptItem
              }
              leafNodeCount
              nodesCount
            }
            elementsCovered {
              leafNodeCount
              nodesCount
            }
          }
          ... on BenchmarkYearlyInsight {
            type
            elementsNotCovered {
              elements {
                id
                label
                children
                parent
                subject
                levelId
                displaySequence
                depth
                type
                isLeaf
                levels {
                  id
                  value
                  count
                }
              }
              nodes {
                id
                label
                children
                parent
                subject
                levelId
                displaySequence
                depth
                type
                isLeaf
                levels {
                  id
                  value
                  count
                }
              }
              leafNodeCount
              nodesCount
            }
            elementsCovered {
              elements {
                id
                label
                children
                parent
                subject
                levelId
                displaySequence
                depth
                type
                isLeaf
                levels {
                  id
                  value
                  count
                }
              }
              nodes {
                id
                label
                children
                parent
                subject
                levelId
                displaySequence
                depth
                type
                isLeaf
                levels {
                  id
                  value
                  count
                }
              }
              leafNodeCount
              nodesCount
            }
          }
          ... on LPAYearlyInsight {
            type
            elementsNotCovered_: elementsNotCovered {
              elements {
                ...lpItem
              }
              nodes {
                ...lpItem
              }
              leafNodeCount
              nodesCount
            }
            elementsCovered {
              leafNodeCount
              nodesCount
            }
          }
        }
        pypFlatYearlyInsight(filters: $filters) {
          ... on ATLYearlyInsight {
            type
            elementsCoverageInsight {
              totalCount
              directlyTaggedUnitPlansCount
              element {
                id
              }
              unitPlans {
                id
              }
              directlyTaggedUnitPlans {
                id
              }
            }
          }
          ... on KeyConceptYearlyInsight {
            type
            elementsCoverageInsight {
              totalCount
              directlyTaggedUnitPlansCount
              element {
                id
              }
              unitPlans {
                id
              }
              directlyTaggedUnitPlans {
                id
              }
            }
          }
          ... on BenchmarkYearlyInsight {
            type
            elementsCoverageInsight {
              totalCount
              directlyTaggedUnitPlansCount
              element {
                id
              }
              unitPlans {
                id
              }
              directlyTaggedUnitPlans {
                id
              }
            }
          }
          ... on LPAYearlyInsight {
            type
            elementsCoverageInsight {
              totalCount
              directlyTaggedUnitPlansCount
              element {
                id
              }
              unitPlans {
                id
              }
              directlyTaggedUnitPlans {
                id
              }
            }
          }
        }
      }
    }
  }
  ${pypElementFragment.concept}
  ${pypElementFragment.lp}
`;
export const getPYPYearlyInsightsInLearningCourseQuery = gql`
  query getPYPYearlyInsightsInLearningCourse(
    $id: ID!
    $filters: PYPCourseYearlyInsightFilters
  ) {
    node(id: $id, type: LEARNING_COURSE) {
      ... on LearningCourse {
        id
        pypLearningCourseOverview(filters: $filters) {
          ... on ATLYearlyInsight {
            type
            elementsNotCovered {
              elements {
                id
                label
                children
                parent
                isLeaf
                atlCategory {
                  id
                }
                subText
                grades {
                  id
                  name
                }
              }
              nodes {
                id
                label
                children
                parent
                isLeaf
                atlCategory {
                  id
                }
                subText
                grades {
                  id
                  name
                }
              }
              leafNodeCount
              nodesCount
            }
            elementsCovered {
              leafNodeCount
              nodesCount
            }
          }
          ... on KeyConceptYearlyInsight {
            type
            elementsNotCovered_: elementsNotCovered {
              elements {
                ...conceptItem
              }
              nodes {
                ...conceptItem
              }
              leafNodeCount
              nodesCount
            }
            elementsCovered {
              leafNodeCount
              nodesCount
            }
          }
          ... on BenchmarkYearlyInsight {
            type
            elementsNotCovered {
              elements {
                id
                label
                children
                parent
                subject
                levelId
                displaySequence
                depth
                type
                isLeaf
                levels {
                  id
                  value
                  count
                }
              }
              nodes {
                id
                label
                children
                parent
                subject
                levelId
                displaySequence
                depth
                type
                isLeaf
                levels {
                  id
                  value
                  count
                }
              }
              leafNodeCount
              nodesCount
            }
            elementsCovered {
              elements {
                id
                label
                children
                parent
                subject
                levelId
                displaySequence
                depth
                type
                isLeaf
                levels {
                  id
                  value
                  count
                }
              }
              nodes {
                id
                label
                children
                parent
                subject
                levelId
                displaySequence
                depth
                type
                isLeaf
                levels {
                  id
                  value
                  count
                }
              }
              leafNodeCount
              nodesCount
            }
          }
          ... on LPAYearlyInsight {
            type
            elementsNotCovered_: elementsNotCovered {
              elements {
                ...lpItem
              }
              nodes {
                ...lpItem
              }
              leafNodeCount
              nodesCount
            }
            elementsCovered {
              leafNodeCount
              nodesCount
            }
          }
        }
        pypFlatLearningCourseOverview(filters: $filters) {
          ... on ATLYearlyInsight {
            type
            elementsCoverageInsight {
              totalCount
              directlyTaggedUnitPlansCount
              element {
                id
              }
              unitPlans {
                id
              }
              directlyTaggedUnitPlans {
                id
              }
            }
          }
          ... on KeyConceptYearlyInsight {
            type
            elementsCoverageInsight {
              totalCount
              directlyTaggedUnitPlansCount
              element {
                id
              }
              unitPlans {
                id
              }
              directlyTaggedUnitPlans {
                id
              }
            }
          }
          ... on BenchmarkYearlyInsight {
            type
            elementsCoverageInsight {
              totalCount
              directlyTaggedUnitPlansCount
              element {
                id
              }
              unitPlans {
                id
              }
              directlyTaggedUnitPlans {
                id
              }
            }
          }
          ... on LPAYearlyInsight {
            type
            elementsCoverageInsight {
              totalCount
              directlyTaggedUnitPlansCount
              element {
                id
              }
              unitPlans {
                id
              }
              directlyTaggedUnitPlans {
                id
              }
            }
          }
        }
      }
    }
  }
  ${pypElementFragment.concept}
  ${pypElementFragment.lp}
`;
export const getCourseOverviewDownloadQuery = gql`
  query getCourseOverviewDownload(
    $id: ID!
    $filters: CourseOverviewDownloadFilters
  ) {
    node(id: $id, type: COURSE) {
      id
      ... on Course {
        id
        courseOverviewDownload(filters: $filters) {
          isSuccess
          url
        }
        __typename
      }
      __typename
    }
  }
`;

export const getOrganizationPlannerTemplatesByGradesQuery = gql`
  query getOrganizationPlannerTemplatesByGrades(
    $id: ID!
    $gradeIds: [ID!]
    $plannerTemplateFilters: TemplateFilters
    $templateFilters: OrganizationTemplateFilter
    $locale: String
  ) {
    node(id: $id, type: ORGANIZATION) {
      id
      ... on Organization {
        grades(ids: $gradeIds) {
          id
          plannerTemplates(filters: $plannerTemplateFilters) {
            id
            subType
          }
        }
        templates(filters: $templateFilters) {
          id
          body(locale: $locale)
          unitType
        }
      }
    }
  }
`;

export const getOrganizationSubjectsQuery = gql`
  query getOrganizationSubjects($id: ID!, $filters: SubjectFilterInput) {
    node(id: $id, type: ORGANIZATION) {
      ... on Organization {
        id
        subjects(filters: $filters) {
          id
          name
        }
      }
    }
  }
`;

export const getPlannerElementNodeSetQuery = gql`
  query getPlannerElementNodeSet(
    $id: ID!
    $type: ENTITY_TYPE_ENUM!
    $plannerElementNodeSetFilters: PlannerElementNodeSetFilters
    $plannerElementNodeFilters: PlannerElementNodeFilters
    $academicYearId: ID
  ) {
    node(id: $id, type: $type) {
      id
      ... on IbMypCurriculumProgram {
        id
        plannerElementNodeSets(filters: $plannerElementNodeSetFilters) {
          ...plannerElementNodeSetItem
          __typename
        }
        __typename
      }
      ... on UBDCurriculumProgram {
        id
        plannerElementNodeSets(filters: $plannerElementNodeSetFilters) {
          ...plannerElementNodeSetItem
          __typename
        }
        __typename
      }
      ... on IbDpCurriculumProgram {
        id
        plannerElementNodeSets(filters: $plannerElementNodeSetFilters) {
          ...plannerElementNodeSetItem
          __typename
        }
        __typename
      }
      ... on IbPypCurriculumProgram {
        id
        plannerElementNodeSets(filters: $plannerElementNodeSetFilters) {
          ...plannerElementNodeSetItem
          __typename
        }
        __typename
      }
      __typename
    }
  }
  ${plannerElementNodeSetFragments.plannerElementNodeSetItem}
`;
